module.exports = __webpack_public_path__ + "img/lg_ring_r_0_1_1@3x.a19f9070.png";